// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3hbg2","footer":"Form_footer__1KP23"};